/*
 * rheincool — Cart-Drawer (Slide-in, HANDOFF.md §5.5)
 * open()/close() mit Fokusfalle und Escape; wird von purchase-options.js
 * und quick-add.js nach dem Hinzufügen geöffnet.
 */
class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-drawer-close]') || event.target.matches('[data-drawer-backdrop]')) {
        this.close();
      }
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
      if (event.key === 'Tab' && this.classList.contains('is-open')) this.trapFocus(event);
    });
  }

  open(options = {}) {
    this.lastFocused = document.activeElement;
    this.classList.add('is-open');
    document.body.classList.add('rc-no-scroll');
    // Erfolgsmoment nur nach Add-to-Cart, nicht beim Öffnen übers Cart-Icon
    const success = this.querySelector('[data-drawer-success]');
    if (success) {
      clearTimeout(this.successTimer);
      if (options.success) {
        success.hidden = false;
        this.successTimer = setTimeout(() => {
          success.hidden = true;
        }, 4000);
      } else {
        success.hidden = true;
      }
    }
    const first = this.querySelector('button, a[href]');
    if (first) first.focus();
  }

  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('rc-no-scroll');
    if (this.lastFocused) this.lastFocused.focus();
  }

  trapFocus(event) {
    const focusables = this.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled])'
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

customElements.define('cart-drawer', CartDrawer);
